import { z } from 'zod';
/**
 * The languages the PORTAL is rendered in — the owner's own reading language
 * (doc 20 D1).
 *
 * Not `Language` (enums.ts), which is what the ASSISTANT speaks to callers: a
 * different axis, owned by the business rather than the user. A Polish owner
 * running a salon in Berlin wants a Polish dashboard and a German assistant.
 *
 * Lives here, not only in the portal, since doc 88: account emails (verify
 * address, reset password) are about the person, not a business, so they are
 * written in the portal locale the request came from — and the callable that
 * carries it needs the enum in its contract (ADR-0008). Every `Language` is
 * also a `UiLocale`; `uk` is the portal-only one.
 */
export const UI_LOCALES = ['en', 'pl', 'de', 'fr', 'uk'];
export const UiLocale = z.enum(UI_LOCALES);
//# sourceMappingURL=uiLocale.js.map